export enum Map3DSidebarOption {
  SlopeMap = 'Slope Map',
  Contour = 'Contour',
  Workspace = 'Workspace',
  Dataset = 'Dataset',
  ElevationTool = 'Elevation Tool',
  VolumeCalculation = 'Volume Calculation',
  Legend = 'Legend',
  SmartDetect = 'Smart Detect',
  BaseMap = 'BaseMap',
  GenerateAnalytics = 'Generate Analytics',
  AdditionalInformation = 'Additional Information',
  HaulRoadAnalytics = 'Haul Road Analytics',
  ComplianceAssessment = 'Compliance Assessment',
  TerrainCleanup = 'Terrain Cleanup',
  DrillAndBlast = 'Drill and Blast',
  GenerateDTM = 'Generate DTM',
  CrossSection = 'Cross Section',
  GenerateDEM = 'Generate DEM',
}

export enum WorkspaceLayerErrorMessage {
  Polygon = 'Please add polygon feature layers to the workspace to proceed.',
  Line = 'Please add line feature layers to the workspace to proceed.',
}

export enum FormErrorMessage {
  NoActivePolygonLayer = 'Please add a vector layer with exactly one polygon feature to the workspace.',
  NoActiveLineLayer = 'Please add a vector layer with exactly one line feature to the workspace.',
  NoActiveWorkspaceLayer = 'Please add a layer with atleast one polygon feature to the workspace to proceed.',
}

export enum CrossSectionErrorMessage {
  NoActiveLineLayer = 'Please add a vector layer with line features to the workspace.',
  NoPointCloudLayer = 'To generate a cross section, please load a point cloud layer into your workspace.',
  NoPointCloudIntersection = 'The selected line does not intersect with the point cloud. Please draw or select a line that crosses the point cloud.',
  SelectLineFeature = 'Click on a line feature in the viewport to select.',
}
